module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video_bg_2-088cbf96f48fa95e60a0975e9df796d9.svg";